var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVoiture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#af975c;}.cls-2{fill:#af975c;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "voiture"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1427",
    "data-name": "Groupe 1427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2400",
    "data-name": "Trac\\xE9 2400",
    className: "cls-1",
    d: "M44.07,36.64a3.43,3.43,0,0,1-3.32,2.46H13.89a3.45,3.45,0,0,1-3.3-2.39,19.06,19.06,0,0,1,0-10.11,3.46,3.46,0,0,1,1.22-1.71l4-9.16A3.49,3.49,0,0,1,19,13.65H35.58a3.5,3.5,0,0,1,3.18,2.08l4,9.1a3.28,3.28,0,0,1,1.33,1.85A20.59,20.59,0,0,1,44.07,36.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1425",
    "data-name": "Groupe 1425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2401",
    "data-name": "Trac\\xE9 2401",
    className: "cls-1",
    d: "M20.63,34.35l-1.47-2.46a1.12,1.12,0,0,0-1-.55H13.45a1.14,1.14,0,0,0-1.13,1.13v2.46a1.13,1.13,0,0,0,1.13,1.12h6.21a1.12,1.12,0,0,0,1.13-1.12A1.06,1.06,0,0,0,20.63,34.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2402",
    "data-name": "Trac\\xE9 2402",
    className: "cls-1",
    d: "M34,34.35l1.48-2.46a1.12,1.12,0,0,1,1-.55h4.75a1.13,1.13,0,0,1,1.12,1.13h0v2.46a1.12,1.12,0,0,1-1.12,1.12H34.92a1.11,1.11,0,0,1-1.12-1.12A1,1,0,0,1,34,34.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    className: "cls-1",
    x: 22.31,
    y: 31.99,
    width: 9.97,
    height: 2.94
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2403",
    "data-name": "Trac\\xE9 2403",
    className: "cls-1",
    d: "M14,24.14l3.37-7.71a1.74,1.74,0,0,1,1.59-1H35.58a1.73,1.73,0,0,1,1.59,1l3.37,7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2404",
    "data-name": "Trac\\xE9 2404",
    className: "cls-1",
    d: "M13.89,39.1a3.87,3.87,0,0,1-1-.16v1.48A1.57,1.57,0,0,0,14.45,42h3.43a1.57,1.57,0,0,0,1.57-1.58V39.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2405",
    "data-name": "Trac\\xE9 2405",
    className: "cls-1",
    d: "M40.75,39.09H35.13v1.33A1.57,1.57,0,0,0,36.7,42h3.43a1.57,1.57,0,0,0,1.57-1.58V39A3.41,3.41,0,0,1,40.75,39.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2406",
    "data-name": "Trac\\xE9 2406",
    className: "cls-1",
    d: "M11.4,25.25a4.59,4.59,0,0,1,.41-.36l1.77-4H10.52a1.73,1.73,0,0,0-1.7,1.4l-.18.93a1.73,1.73,0,0,0,1.36,2,2,2,0,0,0,.34,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2407",
    "data-name": "Trac\\xE9 2407",
    className: "cls-1",
    d: "M46,23.18l-.18-.93a1.74,1.74,0,0,0-1.71-1.4H41l1.74,4a2.86,2.86,0,0,1,.5.42h1A1.73,1.73,0,0,0,46,23.51,1.84,1.84,0,0,0,46,23.18Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoiture);
export default __webpack_public_path__ + "static/media/icon_voiture.27fe6bc4494f9b810752bfbd0cab8727.svg";
export { ForwardRef as ReactComponent };